<template>
  <div class="performance-form">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-button
        v-if="!form.readOnly"
        type="primary"
        :disabled="saving"
        style="position: fixed; right: 10px; z-index: 999"
        @click="submit"
      >确认<span v-if="saving">中...</span></el-button>
      <el-button
        v-if="form.canClose"
        type="warning"
        :disabled="saving"
        style="position: fixed; right: 100px; z-index: 999"
        @click="closeBill"
      >关闭<span v-if="saving">中...</span></el-button>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="应收单" name="first">
          <el-scrollbar>
            <div class="table-form">
              <div class="form-logo">
                <div style="width: 100%">
                  <p class="form-name">
                    应收单
                    <span v-if="form.readOnly" style="color:red;">({{ form.state }})</span>
                  </p>
                </div>
              </div>
              <div class="form-info">
                <p>经销商：{{ form.fDistributor }}</p>
                <p>
                  客户名称：{{ form.fCustomer }}
                  <span v-if="form.readOnly" style="float: right;">确认日期：{{ form.fConfirmDate }}</span>
                  <span v-else style="float: right;">订单日期：{{ form.fDate }}</span>
                </p>
                <p>
                  <span v-if="form.readOnly" style="float: left;margin-left: 0;margin-right: 20%;">应收单号：{{ form.fBillNo }}</span>
                  订单编号：{{ form.fOrderNo }}
                  <span style="float: right;">出仓单号：{{ form.fCkBillNo }}</span>
                </p>
              </div>
              <el-table
                :data="pTableData"
                border
                :span-method="objectSpanMethod"
                style="width: 100%"
                @row-click="tableChange"
              >
                <el-table-column prop="fNumber" label="产品编号" width="" />
                <el-table-column prop="fName" label="产品名称" width="" />
                <el-table-column prop="fModel" label="规格" width="" />
                <el-table-column prop="fOrderQty" label="订单数量" width="" />
                <el-table-column v-if="form.isHasTh" prop="fQty_th" label="退货数量" width="" />
                <el-table-column prop="fQty_qr" label="已确认数" width="" />
                <el-table-column label="确认数量" label-class-name="font-color-red">
                  <template slot-scope="scope">
                    <el-input-currency
                      v-model="scope.row.fQty"
                      :scale="0"
                      :disabled="form.readOnly"
                      :min="0"
                      :max="scope.row.fOrderQty-scope.row.fQty_qr"
                      @input="changeValue(scope.row)"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="fPrice" label="销售单价" width="" />
                <el-table-column prop="total" label="小计" width="" />
              </el-table>
              <div style="text-align:right;padding-right:2%;margin-top:10px;">
                合计:{{ total }}
              </div>
              <hr>
              <div style="text-align:right;padding-right:2%;margin-bottom:3%;">
                <!--
                <div v-if="form.readOnly">
                  付款比例:{{ form.fDeductionRatio }}%
                  付款金额:{{ totalRatio }}
                </div>
                <div v-else>
                  付款金额:{{ totalRatio }}
                  <div style="display:flex;justify-content:flex-end;margin-top:1%;">
                    <el-form-item label="付款比例(%)" prop="fDeductionRatio" style="width:250px">
                      <el-input-currency
                        v-model="form.fDeductionRatio"
                        :scale="2"
                        min="0"
                        max="100"
                      />
                    </el-form-item>
                  </div>
                </div>
                -->
                <div>
                  付款比例:{{ form.fDeductionRatio }}%
                  确认金额:{{ totalRatio }}
                </div>
              </div>
            </div>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment'
import ReturnNode from '@components/ReturnNode'

export default {
  inject: ['getMap'],
  data: function() {
    return {
      form: {},
      pTableData: [],
      rules: {
        fDeductionRatio: [{ required: true, message: '必填项', trigger: 'change' }]
      },

      activeName: 'first',

      saving: false,
      loading: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    total: function() {
      var t = this.form.entrys.reduce((sum, item) => {
        return Number(sum) + Number(item.total)
      }, 0)
      return t.toFixed(2)
    },
    totalRatio: function() {
      var t = this.form.entrys.reduce((sum, item) => {
        return Number(sum) + Number(item.total)
      }, 0)
      return (t * Number(this.form.fDeductionRatio) / 100).toFixed(2)
    }
  },
  mounted() {
    // console.log(this.form, 'this.form')
  },
  activated() {
    this.refresh()
  },
  methods: {
    submit: function() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          const flg = await this.confirm('是否确认?')
          if (!flg) return

          this.saving = true

          this.$httpPost('OrderManage/ArBill/ArBillConfirm', {
            datalist: JSON.stringify(this.form)
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              const tabName = this.$store.state.tabName
              this.getMap(tabName)
              this.$router.push({ path: '/orderManage/arBillAffirm' })
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },
    closeBill: function() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          const flg = await this.confirm('关闭之后不能再做确认操作,是否关闭?')
          if (!flg) return

          this.saving = true

          this.$httpPost('OrderManage/ArBill/ArBillClose', {
            datalist: JSON.stringify(this.form)
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              const tabName = this.$store.state.tabName
              this.getMap(tabName)
              this.$router.push({ path: '/orderManage/arBillAffirm' })
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },

    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    },

    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      const res = await this.$httpPost(
        'OrderManage/ArBill/GetArBill',
        {
          fid: id
        }
      )

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }
      this.form = res.datalist
      this.pTableData = res.datalist.entrys
    },
    changeValue(value) {
      // console.log(value, 'val')
      this.form.entrys.forEach((val) => {
        if (val.fEntryID === value.fEntryID) {
          val.total = (value.fPrice * val.fQty).toFixed(2)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
<style lang="less">
.performance-form {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
  .formitem {
    .el-form-item__label {
      margin: 26px 0;
      // width: 78px !important;
    }
    .el-form-item__content {
      // margin-left: 89px !important;
    }
  }

  .table-form {
    width: 99%;
    table {
      font-size: 12px;
    }
    .el-table {
      color: #000;
    }
    .el-table td,
    .el-table th {
      // padding: 0px 0;
    }
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
    }
    .el-table td,
    .el-table th.is-leaf,
    .el-table--border,
    .el-table--group {
      border-color: black;
    }
    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: black;
    }
    .el-table thead {
      color: #000;
      font-weight: 500;
    }

    .form-logo {
      display: flex;
      div {
        flex-direction: column;
      }

      .form-name {
        font-weight: bold;
        font-size: 25px;
        //font-family: 华文行楷;
        margin: 0 auto;
        text-align: center;
      }
      p {
        margin: 0px;
      }
      .fCompany {
        height: 40px;
        line-height: 40px;
        font-size: 13px;
      }
      .fCompanyEnglish {
        font-size: 7px;
        height: 8px;
      }
    }
    .form-info {

    }

    .a-Table {
      border-collapse: collapse;
      width: 100%;
      // text-align: center;
      // border: 1px solid #000;
      tr {
        display: flex;
        border-right: 1px solid #000;
        td {
          flex: 1;
          border-bottom: none;
          border-right: none;
        }
        th {
          flex: 1;
          text-align: left;
          border-bottom: none;
          border-right: none;
        }
      }
      table,
      td,
      th {
        border: 1px solid #000;
      }
    }
  }
}
</style>
